// tslint:disable
export var EnrollmentApiPaymentType;
(function (EnrollmentApiPaymentType) {
    // No Error
    EnrollmentApiPaymentType["debitcard"] = "debitcard";
    EnrollmentApiPaymentType["check"] = "check";
    EnrollmentApiPaymentType["virtualdebitcard"] = "virtualdebitcard";
    EnrollmentApiPaymentType["thirdpartyadjudication"] = "thirdpartyadjudication";
    EnrollmentApiPaymentType["sitecheckforpatient"] = "sitecheckforpatient";
    EnrollmentApiPaymentType["sitecheckforsite"] = "sitecheckforsite";
    EnrollmentApiPaymentType["efttosite"] = "efttosite";
    EnrollmentApiPaymentType["copaycard"] = "copaycard";
})(EnrollmentApiPaymentType || (EnrollmentApiPaymentType = {}));
//# sourceMappingURL=EnrollmentApiPaymentType.js.map